import { render, staticRenderFns } from "./tab-widget.vue?vue&type=template&id=3862d13c&scoped=true&"
import script from "./tab-widget.vue?vue&type=script&lang=js&"
export * from "./tab-widget.vue?vue&type=script&lang=js&"
import style0 from "./tab-widget.vue?vue&type=style&index=0&id=3862d13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3862d13c",
  null
  
)

export default component.exports